if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }

    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        this.setOpenInstantly(this.openDefault);
      } else {
        this.setOpenInstantly(true);
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }

    setOpenInstantly(value) {
      this.isOpen = value;
      this.toggleAttribute('open', value);
      this.setAttribute('aria-expanded', value ? 'true' : 'false');
      this.setAttribute('aria-controls', this.contentElement.id);
      this.style.height = 'auto';
      this.style.overflow = 'visible';
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}
